export default {
  comingSoonTitle: 'PRÓXIMAMENTE',
  comingSoonTitleAlt: 'COMING SOON',
  comingSoonTaglineStart: 'Soluciones con ',
  comingSoonTaglineHighlight: 'Inteligencia Artificial',
  comingSoonTaglineEnd: ' para hacer crecer tu negocio.',
  comingSoonCta: 'CONTÁCTANOS POR WHATSAPP',
  comingSoonLogoAlt: 'CHARVYS AI Business Solutions, logo oficial',
  comingSoonModelAlt: 'Ejecutiva CHARVYS presentando soluciones con Inteligencia Artificial',
  comingSoonModelTitle: 'CHARVYS - soluciones con inteligencia artificial',
  comingSoonH1: 'CHARVYS - Próximamente: soluciones con Inteligencia Artificial',
  loaderLabel: 'Cargando',
  langLabel: 'Idioma',
  langEs: 'ES',
  langEn: 'EN',
};